// トップスライダーの起動 // Launch the top slider
const fvSwiper = new Swiper(".js-fvSlide", {
  loop: true,
  slidesPerView: 1,
  speed: 1500,
  effect: "fade",
  // fadeEffect: {
  //   crossFade: true,
  // },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  on: {
    init: function () {
      setTimeout(() => {
        document.querySelector('body')?.classList.add('is-fv-loaded');
      }, 500);
    }
  }
});

const introSwiper1 = new Swiper(".js-slide1", {
  loop: true, 
  slidesPerView: 2,
  loopAdditionalSlides: 1,
  speed: 9000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    reverseDirection: true, 
  },
});

const introSwiper2 = new Swiper(".js-slide2", {
  loop: true, 
  slidesPerView: 1.7,
  speed: 12000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
});

jQuery(function($) {

  const interviewSwiper = new Swiper(".js-interviewSlide", {
    loop: true,
    loopAdditionalSlides: 1,
    slidesPerView: 1,
    centeredSlides: true,
    allowTouchMove: true,
    spaceBetween: 40,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

});